import { onDocumentEvent } from '@app/utils/jquery-alternatives'

function openAccountEntries(e: Event): void {
  e.preventDefault()
  e.stopPropagation()

  const button = (e.target as HTMLElement).closest(
    '[data-behaviour="account-entries-modal"]'
  ) as HTMLElement

  const ranges = button?.dataset?.ranges || '[]'
  const parsedRanges = JSON.parse(ranges) as Array<string>

  const analyticalDimensionId = button?.dataset?.analyticalDimensionId ?? '[]'
  const parsedAnalyticalDimensionId = JSON.parse(
    analyticalDimensionId
  ) as Array<number>

  const modalParams = {
    totalValue: button?.dataset?.value,
    periodName: button?.dataset?.periodName,
    ledgerId: button?.dataset?.ledgerId,
    companyId: button?.dataset?.companyId, // used in consolidated companies setup
    includeZerosValue: button?.dataset?.includeZerosValue,
    ranges: parsedRanges,
    addRoundingDifference: button?.dataset?.addRoundingDifference,
    unit: button?.dataset?.unit,
    precision: button?.dataset?.precision,
    analyticalDimensionId: parsedAnalyticalDimensionId,
    starred: button?.dataset?.starred,
  }

  window.modalCitizen.openModalPortal('account-entries-modal', modalParams)
}

onDocumentEvent(
  document,
  'click',
  '[data-behaviour="account-entries-modal"]',
  openAccountEntries
)
